export const channels = {
    '天野ピカミィ': 'UCajhBT4nMrg3DLS-bLL2RCg',
    '緋笠トモシカ': 'UC3vzVK_N_SUVKqbX69L_X4g',
    '磁富モノエ': 'UCaFhsCKSSS821N-EcWmPkUQ',
    '羽渦ミウネル': 'UCE5VgVGRPfNCjXPeTe1QJHA',
    '大門地リューゴン': 'UCivDgaCAh7WPBoKA24WNwJQ'
}
